'use strict';

var Util = require('../UI/Util');

/**
 * Displays a message directly over a specific page element.
 * Can optionally gray out the element while showing the message.  Graying
 * out can be disorienting if the message quickly goes away,
 * so it should probably only be used when the message is guaranteed to
 * appear for at least a few seconds.
 *
 */
var ElementSpecificMessage = function (elementToDisplayOver, message, options) {
    this.initialize(elementToDisplayOver, message, options);
};

ElementSpecificMessage.prototype = {
    _$messageDiv: null,
    _$elementToDisplayOver: null,
    _shouldGreyOut: false,
    _message: null,
    _messageCssClass: null,

    /**
     * @param elementToDisplayOver Can be an element ID or an actual DOM element
     */
    initialize: function (elementToDisplayOver, message, options) {

        if(typeof elementToDisplayOver === 'string'){
            elementToDisplayOver = document.getElementById(elementToDisplayOver);
        }

        if (options) {
            if (options.shouldGrayOut) {
                this._shouldGreyOut = options.shouldGrayOut;
            }

            if (options.messageCssClass) {
                this._messageCssClass = options.messageCssClass;
            }
        }

        this._message = message;
        this._$elementToDisplayOver = jQuery(elementToDisplayOver);
    },

    //We don't init until the first time we need to show() because we
    //have to add elements to the DOM, and in IE, you can't modify
    //the DOM until the page is loaded.  We can't be sure the page
    //has been loaded when the constructor is called, but presumably
    //it will be loaded when show() is called.
    _init: function () {
        this._$messageDiv = jQuery("<div class='elementSpecificMessage'><div class='center-block'><span class='" + this._messageCssClass + "'>" + this._message + '</span></div></div>');
        this._$centerBlock = this._$messageDiv.find(">:first-child");
        this._$messageSpan = this._$messageDiv.find("span." + this._messageCssClass);

        this._$messageDiv.css({
            display: 'none',
            height: this._$elementToDisplayOver.height() + 'px'
        });
        this._$messageDiv.appendTo(this._$elementToDisplayOver);
    },

    show: function () {
        //Do the disabling first so that the message div will
        //appear on top of the gray-out div
        if (this._shouldGreyOut) {
            Util.disable(this._$elementToDisplayOver[0]);
        }

        if (this._$messageDiv == null) {
            this._init();
        }

        this._$messageDiv.show();

        this._$centerBlock.css({
            height: this._$messageSpan.outerHeight(),
            width: this._$messageSpan.outerWidth(),
            paddingTop: (this._$elementToDisplayOver.height() - this._$messageSpan.outerHeight()) / 2
        });
    },

    hide: function () {
        this._$messageDiv.hide();
        Util.enable(this._$elementToDisplayOver[0]);
    }
};

module.exports = ElementSpecificMessage;


//////////////////
// WEBPACK FOOTER
// ./mits/Widgets/ElementSpecificMessage.js
// module id = 19
// module chunks = 0